import Vue from 'vue'
import axios from 'axios'

const $api = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})

function isEmbeddedFrame () {
  try {
    if (window.self !== window.top) return true;
    if (/(?:^|[?&])embed=ghost(?:&|$)/.test(window.location.search || '')) return true;
    return window.sessionStorage?.getItem('embed') === 'ghost';
  } catch (e) {
    return true;
  }
}

function readStoredUser () {
  const primary = isEmbeddedFrame() ? window.sessionStorage : window.localStorage;
  const secondary = isEmbeddedFrame() ? window.localStorage : window.sessionStorage;
  const raw = primary.getItem('user') || secondary.getItem('user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

$api.interceptors.request.use(config => {
  // skip next if url is /driver/ghost-access
  if (config.url.includes('/driver/ghost-access')) {
    console.log('ghosted request', config.url);
    return config;
  }

  // legacy session upgrade: cpf + authTk in body, no bearer
  if (config.url.includes('/driver/auth/log') && config.data?.cpf && config.data?.authTk) {
    return config;
  }

  try {
    const user = readStoredUser();
    if (user?.auth?.jwt) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${user.auth.jwt}`;
    }
  } catch (e) {
    // Fails silently
  }
  return config;
}, error => {
  return Promise.reject(error);
});

Vue.prototype.$api = $api;

export default $api
